import React, { useState } from 'react';
import { Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { PiGolfBold } from "react-icons/pi";
import { BsBuildingFillGear } from "react-icons/bs";
import { Bs123 } from "react-icons/bs";
import { FaHome, FaRegCalendarCheck, FaAward, FaSearch, FaDollarSign } from "react-icons/fa";
import { Link } from 'react-router-dom';  // ✅ Add this

const NavigationBar = ({ currentUser }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <Nav vertical>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/main"><FaHome className='h2' /></NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/search"><FaSearch className='h2' /></NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/upcoming"><FaRegCalendarCheck className='h2' /></NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/booknow"><PiGolfBold className='h2' /></NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/league-payments"><FaDollarSign className='h2' /></NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} className='text-dark' to="/league-scores"><Bs123 className='h2' /></NavLink>
      </NavItem>

      {currentUser?.isOwner && (
        <>
          <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle nav className='text-dark'>
              <BsBuildingFillGear className='h2' />
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem tag={Link} to="/organization">Organization Details</DropdownItem>
              <DropdownItem tag={Link} to="/timeframes">Timeframes</DropdownItem>
              <DropdownItem tag={Link} to="/business-hours">Business Hours</DropdownItem>
              <DropdownItem tag={Link} to="/business-hour-exceptions">Business Hour Exceptions</DropdownItem>
              <DropdownItem tag={Link} to="/business-closures">Business Closures</DropdownItem>
              <DropdownItem tag={Link} to="/services">Services</DropdownItem>
              <DropdownItem tag={Link} to="/service-pricing">Service Pricing</DropdownItem>
              <DropdownItem tag={Link} to="/discount-codes">Discount Codes</DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <NavItem>
            <NavLink tag={Link} className='text-dark' to="/leagues"><FaAward className='h2' /></NavLink>
          </NavItem>
        </>
      )}
    </Nav>
  );
};

export default NavigationBar;
